import { request } from "../network/request";


/**
 * 获取巡检结果列表
 */
export function getXmchecklist(query) {
    return request({
        url: 'xmcheck/xmcheckList',
        method: 'post',
        params: query
    })
}


export function getDictData(dictType, type) {
    return request({
        url: 'system/getDictData',
        method: 'get',
        params: { dictType, type },
    })
}



export function excelExport(query) {
    return request({
        url: 'xmcheck/export',
        method: 'post',
        params: query
    })
}

export function getXmcheck(reviewId) {
    return request({
        url: 'xmcheck/getXmcheck',
        method: 'get',
        params: { reviewId },
    })
}


export function updateXmcheck(data) {
    return request({
        url: 'xmcheck/updateXmcheck',
        method: 'post',
        data: data
    })
}



/**
 * //分总检-指标评价结果列表
 * @param {*} data 
 * @returns 
 */
export function getFzInspecList(data) {
    return request({
        url: 'xmInspect/fzInspecList',
        method: 'get',
        params: data
    })
}

/**
 * 分总检-指标评价结果修改
 * @param {*} xmbh 项目编号
 * @param {*} zbid 指标id
 * @param {*} id 结果id 
 * @param {*} jcnf 检查年份
 * @param {*} jccs 检查次数 1首次 2二次
 * @param {*} jcjg 评价结果 关联字典sys_dict_data xmInspection_fz_pjjg1 xmInspection_fz_pjjg2
 * @param {*} type 指标类型 1子指标 2汇总指标
 * @param {*} ygbh 员工编号
 * @returns 
 */
export function updateFzInspec(data) {
    return request({
        url: 'xmInspect/fzInspecUpdate',
        method: 'post',
        data
    })
}
/**
 * 项目巡检-结果列表
 * @param {*} xmbh 项目编号
 * @param {*} jcnf 检查年份
 * @param {*} xmzt 项目状态
 * @param {*} bmbh 部门编号
 * @param {*} qyzj 区域总监
 * @param {*} zxzj 咨询总监
 * @param {*} xmzj 项目总监
 * @returns 
 */
export function getInspecList(data) {
    return request({
        url: 'xmInspect/inspecList',
        method: 'get',
        params: data
    })
}

/**
 * 项目巡检-结果明细列表
 * @param {*} xmbh 项目编号
 * @param {*} jcnf 检查年份
 * @returns 
 */
export function getInspecMxList(data) {
    return request({
        url: 'xmInspect/inspecMxList',
        method: 'get',
        params: data
    })
}

/**
 * 编辑更新结果
 * @param {*} jgid  结果id
 * @param {*} czqjg 操作前结果
 * @param {*} czhjg 操作后
 * @param {*} gxsm 调整说明
 * @returns 
 */
export function updateXjjg(data) {
    return request({
        url: 'xmInspect/updateXjjg',
        method: 'post',
        data
    })
}

/**
 * 获取总部现场检详情(编辑弹窗）
 * @param {*} data 
 * @returns 
 */
export function getZbInspectById(data) {
    return request({
        url: 'xmInspect/getZbInspectById',
        method: 'get',
        params: data
    })
}
/**
 * 总部现场检列表查询接口
 * @param {*} data 
 * @returns 
 */
export function getZbInspecList(data) {
    return request({
        url: 'xmInspect/zbInspectList',
        method: 'get',
        params: data
    })
}
/**
 * 总部检-数据查看
 * @param {*} rqlx  日期类型
 * @param {*} tjnf  统计年份
 * @param {*} jdyf  季度月份
 * @param {*} type  数据类型1整改任务数、2已完成任务数、3巡检报告
 * @param {*} id  巡检结果id
 * @returns 
 */
export function getZbDialogList(data) {
    return request({
        url: 'xmInspect/zbDataList',
        method: 'get',
        params: data
    })
}

/**
 * 文件上传
 * @param {*} data 
 * @returns 
 */
export function uploadFile(data) {
    return request({
        url: 'xmInspect/upload',
        method: 'post',
        data
    })
}
/**
 * 总部现场检结果保存
 * @param {*} data 
 * @returns 
 */
export function saveZbInspect(data) {
    return request({
        url: 'xmInspect/saveZbInspect',
        method: 'post',
        data
    })
}


/**
 * 项目巡检导出
 * @param {*} data 
 * @returns 
 */
export function exportInspecList(data) {
    return request({
        url: 'xmInspect/exportInspecList',
        method: 'GET',
        params: data
    })
}
/**
 * 导出总部现场检表格
 * @param {*} data 
 * @returns 
 */
export function exportInspectList(data) {
    return request({
        url: 'xmInspect/exportInspectList',
        method: 'post',
        params: data
    })
}
/**
 * 分总检导出
 * @param {*} data 
 * @returns 
 */
export function exportfzInspecList(data) {
    return request({
        url: 'xmInspect/exportfzInspecList',
        method: 'get',
        params: data
    })
}
/**
 * 项目巡检-线上检明细列表导出
 * @param {*} data 
 * @returns 
 */
export function exportInspecMxList(data) {
    return request({
        url: 'xmInspect/exportInspecMxList',
        method: 'get',
        params: data
    })
}


/**
 * 巡检报告删除
 * @param {*} data 
 * @returns 
 */
export function fileDelete(data) {
    return request({
        url: 'xmInspect/fileDelete',
        method: 'get',
        params: data
    })
}

/**
 * 判断是否有权限编辑。用于线上检和分总检
 * @param {*} xmbh 
 * @returns 
 */
export function xmCheckAuthor(data) {
    return request({
        url: 'xmInspect/xmCheckAuthor',
        method: 'get',
        params: data
    })
}

